function transformRichTextBulletList (jsonData) {
    const result = {
        title: jsonData.title,
        description: null,
        bulletList: []
    };

    // Extract description from the first paragraph in richtext content
    const descriptionParagraph = jsonData.richtext?.content?.find((item) => item.type === "paragraph");
    if (descriptionParagraph?.content?.[0]?.text) {
        result.description = descriptionParagraph.content[0].text;
    }

    // Extract bullet list items
    const bulletListContent = jsonData.richtext?.content?.find((item) => item.type === "bulletList");
    if (bulletListContent?.content) {
        result.bulletList = bulletListContent.content
            .filter((listItem) => listItem.type === "listItem")
            .map((listItem) => {
                // Navigate to paragraph -> content -> text
                const paragraph = listItem.content?.find((content) => content.type === "paragraph");
                return paragraph?.content?.[0]?.text || "";
            })
            .filter((text) => text.length > 0); // Remove empty strings
    }

    return result;
}

export { transformRichTextBulletList };